import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-xl-6 mx-auto mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold d-flex align-items-center text-dark mb-2" }, " Select a verification type "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-semobold fs-6" }, [
    /*#__PURE__*/_createTextVNode(" If you need more info, please visit our "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://morrisonrecordsbureau.com/contact-us/",
      class: "link-primary fw-bold"
    }, "Help Page"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_5 = { class: "card mt-10" }
const _hoisted_6 = { class: "card-body pt-0 px-lg-18" }
const _hoisted_7 = { class: "mx-auto w-100 pt-15 pb-10" }
const _hoisted_8 = { class: "fv-row mb-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-4 d-block" }, "Select a verification type ", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Proceed ")
const _hoisted_13 = { class: "svg-icon svg-icon-3 ms-2 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.verificationType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationType) = $event)),
                  placeholder: "Select one",
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.VerificationType), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item,
                        label: _ctx.VerificationType[item],
                        value: _ctx.VerificationType[item]
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: !_ctx.verificationType,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args)))
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ])
              ], 8, _hoisted_10)
            ])
          ])
        ])
      ])
    ])
  ]))
}